import { BillState } from '@mews-commander/data-access';
import { RouteName } from '@mews-commander/enums';
import { getCompanyName, getCustomerFullName } from '@mews-commander/legacy-entities/src/ducks';
import { getBill } from '@mews-commander/legacy-entities/src/ducks/bills';
import { WithId } from '@mews-commander/types';
import { Dash } from '@mews-commander/ui';
import { useCommanderSelector } from '@mews-commander/utils';
import { useResolveRoute } from '@mews/routing';
import { ModalLink } from '../Link';
import { useBillingUrl } from './useBillingUrl';

interface BillLinkWithBillIdProps {
    billId: string;
    displayVirtualBillName?: boolean;
    groupId?: string;
    orderItemIdToHighlight?: string;
}

const AccountName = ({ id }: WithId) => {
    const customerName = useCommanderSelector((state) => getCustomerFullName(state, { id }));
    const companyName = useCommanderSelector((state) => getCompanyName(state, { id }));

    return <>{customerName || companyName}</>;
};

export const BillLinkWithBillId = ({
    billId,
    groupId,
    displayVirtualBillName,
    orderItemIdToHighlight,
}: BillLinkWithBillIdProps) => {
    const bill = useCommanderSelector((state) => getBill(state, { id: billId }));
    const billingUrl = useBillingUrl({
        accountId: bill?.ownerId,
        groupId,
        billId,
        orderItemId: orderItemIdToHighlight,
    });
    const resolveRoute = useResolveRoute();

    if (!bill || !billingUrl) return <Dash />;

    const url = bill.state === BillState.Closed ? resolveRoute(RouteName.BillDetail, { id: bill.id }) : billingUrl;

    return (
        <ModalLink data-bill-link={billId} url={url}>
            {bill.isVirtual && displayVirtualBillName ? <AccountName id={billId} /> : bill.name}
        </ModalLink>
    );
};
